import { mount } from "svelte";
import FloatingActionButton from "./components/pages/FloatingActionButton.svelte";
import { AuthenticationTokenService } from "./lib/AuthenticationTokenService";
import { ShopIntegrationService } from "./lib/ShopIntegrationService";
import { tracking } from "./lib/Tracking";
import { FLOATING_BUTTON_LOCAL_STORAGE_KEY } from "./config";

const target = document.getElementById("cassandra-floating-btn");
const shopIntegration = new ShopIntegrationService();

async function checkConditions() {
    return Promise.all([shopIntegration.canShowChatbotEntrypoint(), shopIntegration.isLoggedInUserInApp(), shopIntegration.isInOnexTestGroup()]);
}

function shouldShowDescription() {
    const wasClosed = localStorage?.getItem(FLOATING_BUTTON_LOCAL_STORAGE_KEY);
    return shopIntegration.getPageCluster() === "Storefront" && !wasClosed;
}

function shouldShowButton(isLoggedInUserInApp: boolean, isInOnexTestGroup: boolean) {
    return (isLoggedInUserInApp && isInOnexTestGroup) || AuthenticationTokenService.hasToken();
}

function trackChatBotViews(isLoggedInUserInApp: boolean, descriptionCanBeShown: boolean) {
    if (!isLoggedInUserInApp) return;

    if (descriptionCanBeShown) {
        tracking.submitMerge({ san_ChatBotView: ["banner"] });
    }

    tracking.submitMerge({ san_ChatBotView: ["actionButton"] });
}

(async () => {
    if (!target) return;

    const [canShowChatbotEntrypoint, isLoggedInUserInApp, isInOnexTestGroup] = await checkConditions();

    if (!canShowChatbotEntrypoint) return;

    const descriptionCanBeShown = shouldShowDescription();
    const showFloatingActionButton = shouldShowButton(isLoggedInUserInApp, isInOnexTestGroup);

    trackChatBotViews(isLoggedInUserInApp, descriptionCanBeShown);

    if (showFloatingActionButton) {
        mount(FloatingActionButton, {
            target,
            props: { href: "/chat" },
        });
    }
})();
